import { GridLoader, PacmanLoader } from "react-spinners";
import "./FallbackSpinner.css";
import { getRandomColor } from "../../../utility/Utils";

function FallbackSpinner() {
  const color = getRandomColor();
  return (
    <div className="fallback-spinner">
      <GridLoader  color={color} />
    </div>
  );
}

export default FallbackSpinner;
